module.exports = __webpack_public_path__ + "media/images/header/phinoe-ed5e9f0cd6a1fbbb348ea46895485cc7.svg";